import { ImageUserCommunity } from '@/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';

const SectionUserCommunity = () => {
  const { t } = useTranslation();
  return (
    <div className="section-user-community">
      <div className="title-section">
        <p className="title">{t('User Community')}</p>
        <span className="tag">(08)</span>
      </div>
      <div className="image-section">
        <img src={ImageUserCommunity} alt="user-community" width={1440} height={641} />
      </div>
      <div className="information">
        <div className="item">
          <p className="title">10,000+</p>
          <p className="desc">
            {t(
              'Global user with strong reception in Japan, Vietnam, India, South Korea, Russia, China, and Brazil'
            )}
          </p>
        </div>
        <div className="item">
          <p className="title">$4,48B+</p>
          <p className="desc">{t('The trading volume  generated')}</p>
        </div>
        <div className="item">
          <p className="title">$15M+</p>
          <p className="desc">{t('AUM. - Titantrading.io')}</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SectionUserCommunity);
